import React from "react";

export default function MuiCheckbox({
    checked,
    indeterminate,
    onChange
}: {
    checked: boolean;
    indeterminate: boolean;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}) {
    return (
        <span
            className={`
                MuiButtonBase-root MuiIconButton-root jss1 MuiCheckbox-root
                MuiCheckbox-colorSecondary styles_cartCheckBox__TfdlH jss2 media-767-t-16
                ${checked ? "Mui-checked MuiIconButton-colorSecondary" : ""}
                ${indeterminate ? "MuiCheckbox-indeterminate" : ""}
            `}
        >
            <span className="MuiIconButton-label">
                <input
                    className="jss4"
                    type="checkbox"
                    checked={checked}
                    onChange={onChange}
                />

                {checked && !indeterminate && (
                    <svg className="MuiSvgIcon-root" viewBox="0 0 24 24">
                        <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                    </svg>
                )}

                {indeterminate && (
                    <svg className="MuiSvgIcon-root" viewBox="0 0 24 24">
                        <path d="M19 13H5v-2h14v2z" />
                    </svg>
                )}

                {!checked && !indeterminate && (
                    <svg className="MuiSvgIcon-root" viewBox="0 0 24 24">
                        <path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" />
                    </svg>
                )}
            </span>
        </span>
    );
}
